namespace appn.views.catalog.index {
    class InitArgs {
        validationErrorMessage: string = appn.emptyString;
    }

    let _initArgs: InitArgs;

    export function init(args: InitArgs): void {
        _initArgs = args;

        addEvents();

        // Allows sales to deep link into a showing dialog when a launch param is passed in, usually from links in CRM emails.
        let launchExample = appn.utils.getUrlParamByName('launch');
        if (launchExample) {
            launchExample = decodeURIComponent(launchExample);
            $(`div[data-item-name="${launchExample}"]`).click();
        }
    }

    function addEvents() {
        $('.storeListing').on('click', function(event) {
            event.stopPropagation();
            showExampleDialog($(this));
        });

        $('#installContent').on('click', function(event) {
            event.stopPropagation();
        });

        $('.btn[name="submitType"]').on('click', function(event) {
            document.forms[1].submit();
        });

        $('.more').on('click', function(event) {
            if ($(this).prev().hasClass('category_open')) {
                $(this).prev().removeClass('category_open');
                $(this).html(appn.strings.viewMore);
            } else {
                $(this).prev().addClass('category_open');
                $(this).html(appn.strings.viewLess);
            }

        });
    }

    function showExampleDialog($exampleTagWithData: any) {
        // Set parameters on form
        const id = $('#itemId');
        const name = $('.modal-title');
        const descr = $('#itemDescription');
        const icon = $('#itemIcon');
        id.val($exampleTagWithData.attr('data-item-id'));
        name.text($exampleTagWithData.attr('data-item-name'));
        descr.html($exampleTagWithData.attr('data-item-descr'));
        icon.attr('src', $exampleTagWithData.data('itemIcon'));
        icon.attr('data-imglazyurl', $exampleTagWithData.data('itemIcon'));

        const bg = $exampleTagWithData.find('.templateItem img').css('background-color');
        icon.css('background-color', bg);

        // Check for error messages and mutate the modal for a new action
        if (_initArgs.validationErrorMessage) {
            let launchExample = appn.utils.getUrlParamByName('launch');
            if (launchExample)
                launchExample = decodeURIComponent(launchExample);

            // Check that it is the correct validated item
            if (String($exampleTagWithData.attr('data-item-name')) === launchExample) {
                // Check if message already added
                const modalwarning = $('#installTemplateDialog').find('.card-body h4');
                if (modalwarning.length === 0)
                    employInstallValidationAndMutation();

            } else
                removeInstallValidationAndMutation();
        }

        $('#installTemplateDialog').modal('show');
    }

    function employInstallValidationAndMutation(): void {
        const parser = new DOMParser();
        const messageDoc = parser.parseFromString(_initArgs.validationErrorMessage, 'text/html');
        const message = $(messageDoc.body).children();

        const messageContainer = document.createElement('div');
        messageContainer.classList.add('alert', 'alert-danger');
        message.appendTo(messageContainer);

        const modal = $('#installTemplateDialog');
        const modalStyle = modal.find('.modal-dialog');
        const modalButtons = modal.find('.modal-toolbar');
        const modalBody = modal.find('.card-body');

        // Change the header style
        modalStyle.removeClass('modal-info');
        modalStyle.addClass('modal-danger');

        // Change buttons and add enableForce
        const installButton = modalButtons.find('#installBtn');
        installButton.removeClass('btn-success');
        installButton.addClass('btn-warning');
        installButton.find('span').text('Overwrite');
        $('#EnableForce').val('true');

        // Add message to body
        modalBody.prepend(messageContainer);
    }

    function removeInstallValidationAndMutation(): void {
        const modal = $('#installTemplateDialog');
        const modalStyle = modal.find('.modal-dialog');
        const modalButtons = modal.find('.modal-toolbar');
        const modalBody = modal.find('.card-body');

        // Change the header style back
        modalStyle.removeClass('modal-danger');
        modalStyle.addClass('modal-info');

        // Change buttons back and remove enableForce
        const installButton = modalButtons.find('#installBtn');
        installButton.removeClass('btn-warning');
        installButton.addClass('btn-success');
        installButton.find('span').text('Install');
        $('#EnableForce').val('false');

        // Remove message from body
        const messageContainer = modalBody.find('div.alert.alert-danger');
        messageContainer.remove();
    }
}
